import { Client } from "../clients/models";
import apiClient from "./apiClient";
import { toast } from "react-toastify";

const getClients = async (): Promise<Client[]> => {
  return apiClient.get(`/clients`);
};

const getClient = async (id): Promise<Client> => {
  return apiClient.get(`/clients/${id}`);
};

const saveClient = async (client: Client): Promise<any> => {
  return client.id
    ? apiClient.put(`/clients/${client.id}`, client).then(v => toast.success("Client Saved."))
      .catch((e) => toast.error("Error Saving client"))
    : apiClient.post(`/clients/`, client).then(v => toast.success("Client Created."))
      .catch((e) => toast.error("Error Saving client"));
};

const clientsService = {
  getClients,
  getClient,
  saveClient
};


export default clientsService;